import { TGraphicDesignLessonConfig, TI18nText } from '../../../models/courses/graphicDesign';

export const missingTranslations = (config: TGraphicDesignLessonConfig,
  language: 'en' | 'ar'): number => {
  const fields: (TI18nText | undefined)[] = [config.brief, ...config.hints,
    ...config.rules.flatMap(rule => [rule.label, rule.failMessage]),
    ...(config.zones ?? []).flatMap(zone => [...zone.options, zone.lesson]),
    ...(config.versions ?? []).map(version => version.label),
    ...(config.choices ?? []).map(choice => choice.label)];
  return fields.filter(field => field?.fr?.trim() && !field[language]?.trim()).length;
};
